/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ExperimentalHeartbeatUserType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditorStartHeartbeatMutation
// ====================================================

export interface EditorStartHeartbeatMutation_experimentalEditorStartHeartbeat_orderedUsers {
  accountId: string;
  heartbeatUserType: ExperimentalHeartbeatUserType;
}

export interface EditorStartHeartbeatMutation_experimentalEditorStartHeartbeat {
  orderedUsers: EditorStartHeartbeatMutation_experimentalEditorStartHeartbeat_orderedUsers[] | null;
  editorSessionId: string | null;
  error: string | null;
  message: string | null;
}

export interface EditorStartHeartbeatMutation {
  experimentalEditorStartHeartbeat: EditorStartHeartbeatMutation_experimentalEditorStartHeartbeat | null;
}

export interface EditorStartHeartbeatMutationVariables {
  contentId: string;
  contentType: string;
  collabService: string;
  heartbeatUserType?: ExperimentalHeartbeatUserType | null;
}
